import { BaseCommandProvider } from "common/app/command-palette/providers/base-provider";
import { Command, GetCommandsProps } from "common/app/command-palette/types";
import { getUserMenuEntries } from "x/layout/navigation/functions";

export class MenuProvider extends BaseCommandProvider {
  getCommands({ context }: GetCommandsProps): Command[] {
    return (
      getUserMenuEntries(context)
        // Entities are provided by the entity provider
        .filter((e) => !e.entityName && !e.reportId)
        .map((entry) => ({
          id: `menu:${entry.link}`,
          label: entry.label,
          icon: entry.icon,
          link: entry.link,
          category: "menu",
        }))
    );
  }
}
